import { render } from "./ContactUserContainer.vue?vue&type=template&id=1ac6ba4d&ts=true"
import script from "./ContactUserContainer.vue?vue&type=script&lang=ts"
export * from "./ContactUserContainer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__